(function($){
	$(function(){
		var $btn = $('.navbar-burger');
		var $nav = $('#navbarNav');

		$btn.on('click', function(e){
			e.preventDefault();
			var open = $btn.attr('aria-expanded') === 'true';
			$btn.attr('aria-expanded', open ? 'false' : 'true');
			$nav.toggleClass('active', !open);
		});

		var $sticky = $('[data-sticky-header]');
		var $first  = $('.header--primary').length ? $('.header--primary') : $('header.header').first();
		if(!$sticky.length || !$first.length) return;

		var H = 1;
		function measure(){ H = $first.outerHeight(true) || 1; }
		function render(){
			var y = window.pageYOffset || 0;
			var p = Math.max(0, Math.min(y / H, 1));         // 0..1
			var ty = -100 + 100 * p;                          // -100% .. 0%
			$sticky.css({
				transform: 'translateY(' + ty + '%)',
				opacity: 1,
				'pointer-events': p >= 0.98 ? 'auto' : 'none'
			});
		}

		measure(); render();
		$(window).on('scroll', function(){ requestAnimationFrame(render); });
	});
})(jQuery);
